import { useContext, useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import AppContext from "../../context";

import styles from '../../styles/Sidebar.module.scss';
import SidebarMembershipStatus from "../components/SidebarMembershipStatus";

function Sidebar() {
	const context = useContext(AppContext);

	const [open, setOpen] = useState(false);
	const isHybrid = context.domain.businessType === 'hybrid' || context.domain.businessType === 'hybrid-new';
	const tokenSummary = context.domain.businessType === 'hybrid-new'
		? `${context.user.openGymBalance || 0} open gym tokens and ${context.user.classBalance || 0} class tokens`
		: `${context.user.walletBalance || 0} tokens`;

	return (
		<div className={`${styles.sidebar} ${open ? styles.open : null}`}>
			<Link to="/">
				<img src={context.domain.logo || `https://surecode.fra1.cdn.digitaloceanspaces.com/${context.domain._id}/logo.svg`} alt={context.domain.name} />
			</Link>

			{context.domain.membershipMode ?
				<div className={styles.nav}>
					<p>Hey <strong>{context.user.firstName}</strong>, welcome to {context.domain.name}.</p>

					<SidebarMembershipStatus />

					<nav onClick={() => { setOpen(false) }}>
						<NavLink to="/dashboard/membership">Membership</NavLink>
						<NavLink to="/dashboard/personal-access-code">Personal Access Code</NavLink>
						<NavLink to="/dashboard/settings">Settings</NavLink>
						<NavLink to="/log-out">Log Out</NavLink>
						<p>Powered by <a href="https://surecodesoftware.com/" target="_blank" rel="noopener noreferrer">Surecode</a></p>
					</nav>
				</div>
			: (context.domain.businessType === 'clinic' || context.domain.businessType === 'salon' || context.domain.businessType === 'restaurant') ?
				<div className={styles.nav}>
					<p>Hey <strong>{context.user.firstName}</strong>, welcome to {context.domain.name}.</p>
					<nav onClick={() => { setOpen(false) }}>
						<NavLink to="/dashboard/services">Browse Services</NavLink>
						<NavLink to="/dashboard/my-service-bookings">My Appointments</NavLink>
						{context.domain.walletEnabled ? <NavLink to="/dashboard/wallet">Wallet</NavLink> : null}
						<NavLink to="/dashboard/settings">Settings</NavLink>
						<NavLink to="/log-out">Log Out</NavLink>
						<p>Powered by <a href="https://surecodesoftware.com/" target="_blank" rel="noopener noreferrer">Surecode</a></p>
					</nav>
				</div>
			: isHybrid ?
				<div className={styles.nav}>
					<p>Hey <strong>{context.user.firstName}</strong>, you have <strong>{tokenSummary}</strong>.</p>
					<nav onClick={() => { setOpen(false) }}>
						<NavLink to="/dashboard/membership">Membership</NavLink>
						<NavLink to="/dashboard/book">New Booking</NavLink>
						<NavLink to="/classes">Classes</NavLink>
						<NavLink to="/dashboard/bookings">Manage Bookings</NavLink>
						<NavLink to="/account">Class Bookings</NavLink>
						<NavLink to="/dashboard/tokens">Purchase Tokens</NavLink>
						<NavLink to="/dashboard/settings">Settings</NavLink>
						<NavLink to="/log-out">Log Out</NavLink>
						<p>Powered by <a href="https://surecodesoftware.com/" target="_blank" rel="noopener noreferrer">Surecode</a></p>
					</nav>
				</div>
			:
				<div className={styles.nav}>
					<p>Hey <strong>{context.user.firstName}</strong>, you have <strong>{context.user.balance}</strong> tokens.</p>
					<nav onClick={() => { setOpen(false) }}>
						<NavLink to="/dashboard/book">New Booking</NavLink>
						<NavLink to="/dashboard/bookings">Manage Bookings</NavLink>
						<NavLink to="/dashboard/tokens">Purchase Tokens</NavLink>
						{context.domain.paidExtrasAvailable && <NavLink to="/dashboard/membership">Paid Extras</NavLink>}
						{context.user.paidExtrasActive && <NavLink to="/dashboard/personal-access-code">Personalized PIN</NavLink>}
						<NavLink to="/dashboard/settings">Settings</NavLink>
						<NavLink to="/log-out">Log Out</NavLink>
						<p>Powered by <a href="https://surecodesoftware.com/" target="_blank" rel="noopener noreferrer">Surecode</a></p>
					</nav>
				</div>
			}

			<div id="hamburger" onClick={() => { setOpen(!open) }} className={open ? "close" : null}><span /></div>

			<span />
		</div>
	);
}

export default Sidebar;
